<template>
  <div class="nav_section">
    <v-navigation-drawer
      app
      permanent
      class="right-shadow sidebar_background drawer-dims naw_drawer_width"
      mini-variant
      mini-variant-width="6vw"
    >
<!--      mini-variant-width="7vw"-->
      <v-list-item class="logo_background pa-0 ma-0">
        <v-list-item-content class="pa-0 ma-0">
          <router-link to="/dashboard">
            <div
              class="logo_background navbar-div hgfix "
              id="logo-container"
            >
              <NavIcon class="navicon" />
            </div>
          </router-link>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list>
        <br />
        <br />
        <br />
        <v-list-item-group mandatory dark>
          <v-list-item
            class="list-dim "
            @click="setSelected('Dashboard'),campingsMenu = false,campaignsList = false"
            @mouseenter="setHover('Dashboard')"
            @mouseleave="setHover('')"
            to="/dashboard"
            >
            <v-icon class="navicon_scale"
              >$vuetify.icons.dashboard</v-icon
            ></v-list-item
          >
          <v-list-item
            class="list-dim widg_nav_item"
            @click="setSelected('Widgets'),campingsMenu = false,campaignsList = false"
            @mouseenter="setHover('Widgets')"
            @mouseleave="setHover('')"
            @focusout="campingsMenu = false"
            to="/widgets"
            >
            <v-icon class="navicon_scale"
              >$vuetify.icons.widgets</v-icon
            ></v-list-item
          >
          <v-menu right offset-x  :open-on-hover="campingsMenu" :menu-props="{ 'margin-top': '0px !important'}"
                  content-class="elevation-0 mt-0"
                  class="box_shadow_none">
            <template v-slot:activator="{ on, attrs }" >
              <div  @mouseleave="activeCamp = ''">
                <v-list-item
                  class="list-dim campaigns_section "
                  :class="[campingsMenu == true || $router.currentRoute.fullPath == '/campaigns-facebook'
                || $router.currentRoute.fullPath == '/campaigns-sms' || $router.currentRoute.fullPath == '/campaigns-whatsapp'
                 ? `${campaignsList,activeCamp}`  :  '',cmp_sec]"
                  @mouseover="campingsMenu = true"
                  @mouseenter="setHover('Campaigns'), activeCamp = 'activeBg'"
                  @mouseleave="setHover('') "
                  v-bind="attrs"
                  v-on="on"

                >
                  <v-icon class="navicon_scale"  >$vuetify.icons.campaigns </v-icon>
                </v-list-item>
              </div>
            </template>

            <v-col
              cols="12"
              class="par_tool_tip px-0 pl-3 my-0 py-0 "
              v-if="campingsMenu"
              @mouseenter="activeCamp = 'activeBg',setHover('Campaigns')"
              @mouseleave="activeCamp = '',setHover('')"
            >
              <v-col cols="12" class="tool_tip px-0 py-0 text-center" @click="setSelected('Campaigns')">
                <router-link class="tool_tip_span" to="/campaigns-sms">{{
                    $t("campaigns.tooltip.sms")
                  }}</router-link>
                <router-link class="tool_tip_span" to="/campaigns-whatsapp">{{
                    $t("campaigns.tooltip.wa")
                  }}</router-link>
                <router-link class="tool_tip_span" to="/campaigns-facebook">{{
                  $t("campaigns.tooltip.facebook")
                }}</router-link>
                <v-col cols="12" class="arrow-right_nav py-0"></v-col>
              </v-col>
            </v-col>
          </v-menu>

          <v-list-item
            class="list-dim"
            @click="setSelected('AbandonedCarts'),campingsMenu = false,campaignsList = false"
            @mouseenter="setHover('AbandonedCarts')"
            @mouseleave="setHover('')"
            to="/abandonedcarts"
            ><v-icon class="navicon_scale"
              >$vuetify.icons.abandonedCarts</v-icon
            ></v-list-item
          >

          <v-list-item
            class="list-dim"
            @click="setSelected('Settings'),campingsMenu = false,campaignsList = false"
            @mouseenter="setHover('Settings')"
            @mouseleave="setHover('')"
            to="/settings"
            ><v-icon class="navicon_scale"
              >$vuetify.icons.settings</v-icon
            ></v-list-item
          >
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import NavIcon from "@/assets/icons/sidebar/icon-logo-icon.svg";
export default {
  name: "NavDrawer",
  components: {
    NavIcon,
  },
  data() {
    return {
      model: 1,
      preActive: "",
      campingsMenu: false,
      campaignsList:'campaign_list',
      noneStyleActive:false,
      cmp_sec:'cmp_sec',
      activeCamp:'activeBg'
    };
  },
 watch:{
   "$route":{
     deep: true,
     handler(){
       if(this.$route.name == 'CampaignsSms' || this.$route.name == 'Campaigns' || this.$route.name == 'CampaignsWhatsApp'){
         this.campaignsList = 'campaign_list';   this.campingsMenu = true;
         this.cmp_sec = false
       }else  this.campaignsList = false;   this.campingsMenu = false; this.cmp_sec = 'cmp_sec'
       // /* conitnue below tommorow*/
       // if(this.$route.name == 'Dashboard'){
       //   this.$store.commit('SET_DEFAULT_NAVSTATE')
       //   setTimeout(() =>  this.setHover("Dashboard"),500)
       // }else if(this.$route.name == 'AbandonedCarts'){
       //   this.$store.commit('SET_DEFAULT_NAVSTATE')
       //   setTimeout(() =>  this.setHover("AbandonedCarts"),500)
       // }
       switch(this.$route.name) {
         case 'Dashboard':
           // this.$store.commit('SET_DEFAULT_NAVSTATE')
           setTimeout(() =>  this.setHover("Dashboard"),500)
           break;
         case 'Widgets':
           this.$store.commit('SET_DEFAULT_NAVSTATE')
           setTimeout(() =>  this.setHover("Widgets"),500)
           break;
         case 'Campaigns':
           this.activeCamp = 'activeBg'
           this.$store.commit('SET_DEFAULT_NAVSTATE')
           setTimeout(() =>  this.setHover("Campaigns"),500)
           break;
         case 'CampaignsSms':
           this.activeCamp = 'activeBg'
           this.$store.commit('SET_DEFAULT_NAVSTATE')
           setTimeout(() =>  this.setHover("Campaigns"),500)
           break;
         case 'CampaignsWhatsApp':
           this.activeCamp = 'activeBg'
           this.$store.commit('SET_DEFAULT_NAVSTATE')
           setTimeout(() =>  this.setHover("Campaigns"),500)
           break;
         case 'AbandonedCarts':
           this.$store.commit('SET_DEFAULT_NAVSTATE')
           setTimeout(() =>  this.setHover("AbandonedCarts"),500)
           break;
         case 'Settings':
           this.$store.commit('SET_DEFAULT_NAVSTATE')
           setTimeout(() =>  this.setHover("Settings"),500)
           break;
         default:
           // this.$store.commit('SET_DEFAULT_NAVSTATE')
           // setTimeout(() =>  this.setHover("Dashboard"),500)
       }
    }
  },
    activeCamp(){
      if(this.$route.name == 'CampaignsSms' || this.$route.name == 'Campaigns' || this.$route.name == 'CampaignsWhatsApp'){
        this.activeCamp = 'activeBg'
        this.setHover("Campaigns")
      }
    }
 },
  methods: {
    setSelected(id) {
      this.$store.dispatch("updateClick", id);
      if (id == "Campaigns") {
        this.$store.dispatch("updActiveTab", "abndndcrt1").then(() => {
          this.$store.dispatch("updCart1Active", true);

        });
      }
    },
    setHover(id) {
        this.$store.dispatch("updateHover", id);
    },

  },
  computed: {
    ...mapActions(["updateClick"]),
  },
};
</script>

<style  lang="scss">
.campaigns_section{
  &::before{
    background-color: transparent !important;
  }
}
.widg_nav_item{
  .span-prop{
    white-space: pre-line;
    text-align: center;
  }
}
.nav_section{
  .span-prop{
    font-size: 12px !important;
  }
}

</style>

<style scoped>
.activeBg{
  background-color: #323f4e91 !important;;
}
.naw_drawer_width{
  min-width: 6vw !Important;
}
@media only screen and (max-width: 1099px) {
  .naw_drawer_width {
    min-width: 7vw !important;
  }
}
@media only screen and (max-width: 999px) {
  .naw_drawer_width {
    min-width: 8vw !important;
  }
}
@media only screen and (max-width: 899px) {
  .naw_drawer_width {
    min-width: 9vw !important;
  }
}
@media only screen and (max-width: 799px) {
  .naw_drawer_width {
    min-width: 10vw !important;
  }
  .span-prop{
    font-size: 10px !important;
  }
}
@media only screen and (max-width: 599px) {
  .naw_drawer_width {
    min-width: 12vw !important;
  }
  .span-prop{
    font-size: 10px !important;
  }
}
</style>

<style>
.box_shadow_none{
  box-shadow: navy;
}
.cmp_sec:hover{
  /*color: #FFFFFF !important;*/
  background-color:#ffffff16 !important;
}
.navbar-div {
  top: 0;
  left: 0;
  width: 6vw;
  height: 10vh;
  text-align: center;
  text-justify: center;
  align-content: center;
  padding: 20%;
}
.list-dim {
  align-content: center;
  height: 70px;
}
.campaign_list{
  background-color:#323f4e91 !important;
}
.navicon {
  fill: #ffd85c;
}
.right-shadow {
  box-shadow: 2px 0 8px rgb(146, 143, 143);
}

.drawer-dims {
  height: 100% !important;
}

.navicon_scale {
  transform: scale(0.75);
}
.tool_tip {
  background-color: #4f5d6a;
  width: 250px !important;
}
.par_tool_tip {
  background-color: #e6e7e800 !important;
  width: 152px !important;
  height: 120px !important;

}
.tool_tip_span {
  font-size: 10px;
  padding: 12px 11px;
  white-space: nowrap;
  align-content: center;
  color: #ffffff !important;
  caret-color: #ffffff !important;
  display: block;
  background-color: #323f4e;
}
.tool_tip_span:hover {
  color: #5685e9 !important;
}

.arrow-right_nav {
  width: 0;
  height: 0;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-right: 10px solid #323F4F;
  position: absolute;
  top: 38%;
  left: -22px;
}

 .v-menu__content {
  box-shadow: none !important;
  border-radius: 0px !important;
  margin-top: 12px !important;
  cursor: pointer;
}
.hgfix {
  height: 80px !important;
}
.none_style_active>.v-list-item--link::before {
   background-color:transparent !important;
 }
@media (min-width: 1400px) {
  .navicon_scale {
    transform: scale(0.9);
  }

  .list-dim {
    height: 90px;
  }
}
@media only screen and (max-width: 1399px) {
  .par_tool_tip {
    margin-top: 0px !important;
    height: 110px !important;
  }
 .v-menu__content {

    margin-top: 0px !important;
    cursor: pointer;
  }
  .par_tool_tip a{
    padding-top: 10px !important;
    padding-bottom:10px !important;
  }
}

@media only screen and (max-width: 799px) {
  .span-prop{
    font-size: 10px !important;
  }
}
</style>
